/**
 * Payment Service - Handles API calls for payment methods
 */
class PaymentService {
    #axiosInstance;
    constructor(cashQoreAxiosInstance) {
        this.#axiosInstance = cashQoreAxiosInstance;
        console.log('PaymentService initialized with base URL:', cashQoreAxiosInstance.defaults.baseURL);
    }
    /**
     * Fetch payment methods for a specific client
     * @param {string} clientId - The client ID
     * @returns {Promise<Array>} Array of payment method objects
     */
    async getPaymentMethods(clientId) {
        try {

            const response = await this.#axiosInstance.get(`/payments/get-bank-accounts/${clientId}`);
            if (!response.status === 200) {
                throw new Error(`Failed to fetch payment methods: ${response.status} ${response.statusText}`);
            }

            const bankAccounts = await response.data.data.bankAccounts;
            return bankAccounts;
        } catch (error) {
            //TODO: Handle error more gracefully in production
            return []
        }
    }

    /**
     * Save a new payment method for a client
     * @param {string} clientId - The client ID
     * @param {Object} paymentMethodData - Payment method data
     * @returns {Promise<Object>} The saved payment method object
     */
    async savePaymentMethod(clientId, paymentMethodData) {
        try {

            let body = JSON.stringify(paymentMethodData);
            const response = await this.#axiosInstance.post(`/payments/record-transaction/${clientId}`, body);
            const data = await response.data;
            return data;
        } catch (error) {
            throw error;
        }
    }

    /**
     * Submit a payment
     * @param {string} clientId - The client ID
     * @param {Object} paymentData - Payment data
     * @returns {Promise<Object>} The payment confirmation object
     */
    async submitPayment(clientId, paymentData) {
        try {
            let body = JSON.stringify(paymentData);
            const response = await this.#axiosInstance.post(`/payments/record-transaction/${clientId}`, body);
            const data = await response.data;
            return data;
        } catch (error) {
            throw error;
        }
    }

    /**
     * Get fallback payment methods for testing/demo purposes
     * @returns {Array} Array of demo payment method objects
     */
    getFallbackPaymentMethods() {
        return [
            { PaymentName: 'My Bank Account', PaymentId: 23466, isActive: true },
            { PaymentName: 'Business Checking', PaymentId: 23467, isActive: true },
            { PaymentName: 'Savings Account', PaymentId: 23468, isActive: false },
            { PaymentName: 'Credit Union', PaymentId: 23469, isActive: true }
        ];
    }
}

// Export a singleton instance
export default PaymentService;
